import { useSelector } from 'react-redux';
import { JOB_STATUSES } from '@helpers';
import { RootState } from '@store/types';
import { UseElapsedTimeParams } from '@v2/pages/planboard/types';

const useElapsedTime = (item: UseElapsedTimeParams) => {
  const offset = useSelector((state: RootState) => state.time?.server?.offset ?? 0);
  const offsetInSeconds = Math.floor(offset / 1000);
  const elapsedTimeValue = item.totalTimeActualSeconds != null ? item.totalTimeActualSeconds + offsetInSeconds : 0;
  const shouldRunTime = item.totalTimeActualSeconds != null && item.status === JOB_STATUSES.RUNNING;

  return { elapsedTimeValue, shouldRunTime };
};

export default useElapsedTime;
